module.exports = __webpack_public_path__ + "static/media/bg_setting_backe43349e9d3554d98b8d7bb390e6a06fb.webp";